import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { deepEqual } from "../../../utils/object";

class TextEx extends React.Component {
    constructor(props) {
        super(props);
        if (typeof props.data === "object") props.data = "";

        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default ?? "",
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }    

    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? "";
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }
    
    onChange = (e) => {
        const newValue = e.target.value;
        if (this.state.data === newValue) return;
        
        this.setState({
            data: newValue
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    render() {
        return (<>
            <Row className="g-3">
                <Col>
                    <div className="mb-3 top-label">
                        <Form.Control type="text" name={ this.props.element } value={this.state.data || ""} onChange={this.onChange} readOnly={this.state.locked} />
                        <Form.Label>{ this.state.label }</Form.Label>
                    </div>
                </Col>
            </Row>
        </>)
    }
}

export default TextEx;